import React from 'react';

import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import { useSubheader } from '../../../_metronic/layout';
import { gradingFields } from '../../../airtable/metadata/grading';
import { createColumn } from '../../components/dynamic-table';

import { GradingDCITable } from './tables/dci';
import { GradingDestinationTable } from './tables/destination';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
}));

const commonColumns = [
  createColumn(gradingFields.YEAR, { type: 'numeric' }),
  createColumn(gradingFields.CARD_NAME, { type: 'string', title: 'Player' }),
  createColumn(gradingFields.SET, { type: 'string' }),
  createColumn(gradingFields.CARD_NUMBER, { type: 'string' }),
];

const destinationColumns = [
  ...commonColumns,
  createColumn(gradingFields.ORDER_NUMBER, { type: 'numeric' }),
  createColumn(gradingFields.ORDER_STATUS, { type: 'numeric' }),
];

const bases = [
  { base: 'DCI', columns: commonColumns, dci: true },
  { base: 'PSA', columns: destinationColumns },
  { base: 'BGS', columns: destinationColumns },
  { base: 'CSG', columns: destinationColumns },
];

export function GradingPage() {
  const subheader = useSubheader();
  subheader.setTitle('Grading');

  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  const { base, columns, dci } = bases[value];

  return (
    <div className={classes.root}>
      <Paper square>
        <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleChange}>
          {bases.map(({ base }) => <Tab key={base} label={base} />)}
        </Tabs>
      </Paper>

      {dci
        ? <GradingDCITable base={base} commonColumns={columns} />
        : <GradingDestinationTable base={base} columns={columns} />}
    </div>
  );
}
